var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#3178c6",
    height: 28,
    rx: 1.312,
    width: 28,
    x: 2,
    y: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.245 23.759v3.068a6.492 6.492 0 0 0 1.764.575 11.56 11.56 0 0 0 2.146.192 9.968 9.968 0 0 0 2.088-.211 5.11 5.11 0 0 0 1.735-.7 3.542 3.542 0 0 0 1.181-1.266 4.469 4.469 0 0 0 .186-3.394 3.409 3.409 0 0 0 -.717-1.117 5.236 5.236 0 0 0 -1.123-.877 12.027 12.027 0 0 0 -1.477-.734q-.6-.249-1.08-.484a5.5 5.5 0 0 1 -.813-.479 2.089 2.089 0 0 1 -.516-.518 1.091 1.091 0 0 1 -.181-.618 1.039 1.039 0 0 1 .162-.571 1.4 1.4 0 0 1 .459-.436 2.439 2.439 0 0 1 .726-.283 4.211 4.211 0 0 1 .956-.1 5.942 5.942 0 0 1 .808.058 6.292 6.292 0 0 1 .856.177 5.994 5.994 0 0 1 .836.3 4.657 4.657 0 0 1 .751.422v-2.863a7.509 7.509 0 0 0 -1.525-.4 12.426 12.426 0 0 0 -1.9-.129 8.767 8.767 0 0 0 -2.064.235 5.239 5.239 0 0 0 -1.716.733 3.655 3.655 0 0 0 -1.171 1.271 3.731 3.731 0 0 0 -.431 1.845 3.588 3.588 0 0 0 .789 2.34 6 6 0 0 0 2.395 1.639q.63.26 1.175.509a6.458 6.458 0 0 1 .942.517 2.463 2.463 0 0 1 .626.585 1.2 1.2 0 0 1 .23.719 1.1 1.1 0 0 1 -.144.552 1.269 1.269 0 0 1 -.435.441 2.381 2.381 0 0 1 -.726.292 4.377 4.377 0 0 1 -1.018.105 5.773 5.773 0 0 1 -1.969-.35 5.874 5.874 0 0 1 -1.805-1.045zm-5.154-7.638h4v-2.527h-11.153v2.527h3.982v11.254h3.171z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs);
export default __webpack_public_path__ + "static/media/ts.f59b0ca90862bb487ea70d054135f09f.svg";
export { ForwardRef as ReactComponent };